// extracted by mini-css-extract-plugin
export default {"wrap":"HN-z","subtitle":"IN-z","contentWrap":"JN-z","imgWrap":"KN-z","heading":"LN-z","copy":"MN-z"};